import { CrossTabTokenRefresh } from './crossTabTokenRefreshService';

// Create a singleton instance in a separate file. This allows us to import the class without
// initializing it, which is particularly useful for tests.
const crossTabTokenRefreshService = new CrossTabTokenRefresh();

export default crossTabTokenRefreshService;
